import { createSlice } from "@reduxjs/toolkit"
import { SCENARIO_LIST_FILTERS, SCENARIO_TYPE_FILTER } from "../utilities/constants"

const ScenarioSlice = createSlice({
  name: "scenario",
  initialState: {
    isScenarioEdited: false,
    filters: {
      [SCENARIO_LIST_FILTERS.SCENARIO_TYPE]: SCENARIO_TYPE_FILTER.ALL,
    },
    searchText: "",
  },
  reducers: {
    setIsScenarioEdited(state, action) {
      state.isScenarioEdited = action.payload
    },

    // Search Actions
    setSearchText: (state, action) => {
      const _searchText = action?.payload
      state.searchText = typeof _searchText === "string" ? _searchText.trim() : ""
    },

    // ScenarioList Filter Actions
    // action.payload to be like { filterParam: string, filterValue: string | string[] }
    setScenarioFilter: (state, action) => {
      const filterKey = action?.payload.filterParam
      const filterValue = action?.payload.filterValue
      const filters = { ...state.filters }
      if (Object.keys(state.filters).includes(filterKey)) {
        filters[filterKey] = filterValue
      }
      state.filters = { ...filters }
    },
  },
})

export const ScenarioActions = ScenarioSlice.actions
export default ScenarioSlice
